import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
} from '@material-ui/core';
import { styled } from '@material-ui/core/styles';
import { createSort } from '../general/utils/utils';

const baseHeaderColumns = [
  {
    id: 'prospectId',
    label: 'Prospect id',
  },
];

const optionalColumns = {
  sysFailure: {
    id: 'sysFailure',
    label: 'System Failure',
  },
  nonComm: {
    id: 'nonComm',
    label: 'Non Comm',
  },
  underPerf: {
    id: 'underPerf',
    label: 'Under Performance',
  },
  nullNan: {
    id: 'nullNan',
    label: 'Consecutive Null/NaN',
  },
  errorSites: {
    id: 'errorSites',
    label: 'Site Has Errors',
  },
};

const Container = styled(Paper)({
  margin: 20,
  padding: 20,
});

const TableHeightContainer = styled(TableContainer)({
  maxHeight: 500,
});

const AdsRulesTable = ({ activeEndpoints, data }) => {
  const [tablePage, setTablePage] = useState(0);
  const [tableRowCount, setTableRowCount] = useState(25);
  const [sortOrder, setSortOrder] = useState('asc');
  const [sortColumn, setSortColumn] = useState(null);
  const handleSort = (id) => {
    if (sortColumn === id) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortOrder('asc');
      setSortColumn(id);
    }
  };
  const sortFunc = createSort(sortColumn, sortOrder === 'asc' ? -1 : 1);
  const headerColumns = baseHeaderColumns.concat(
    Object.keys(activeEndpoints)
      .filter(a => activeEndpoints[a])
      .map(a => optionalColumns[a]),
  );

  return (
    <Container elevation={3}>
      <TableHeightContainer>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {headerColumns.map(cell => (
                <TableCell
                  key={cell.id}
                  align="left"
                >
                  <TableSortLabel
                    active={sortColumn === cell.id}
                    direction={sortColumn === cell.id ? sortOrder : 'asc'}
                    onClick={() => handleSort(cell.id)}
                  >
                    {cell.label}
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.sort(sortFunc)
              .slice(tablePage * tableRowCount, tablePage * tableRowCount + tableRowCount)
              .map(row => (
                <TableRow
                  hover
                  key={`${row.prospectId}`}
                  onClick={() => window.open(`${window.location.origin}/site/${row.prospectId}`, '_blank')}
                >
                  {headerColumns.map(column => (
                    <TableCell
                      key={`${row.prospectId}${column.id}`}
                      align="left"
                    >
                      {row[column.id] ? row[column.id] : '-'}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableHeightContainer>
      <TablePagination
        component="div"
        count={data.length}
        onChangePage={(e, page) => setTablePage(page)}
        page={tablePage}
        rowsPerPage={tableRowCount}
        rowsPerPageOptions={[10, 25, 50]}
        onChangeRowsPerPage={(e) => {
          setTableRowCount(parseInt(e.target.value, 10));
          setTablePage(0);
        }}
      />
    </Container>
  );
};

AdsRulesTable.propTypes = {
  activeEndpoints: PropTypes.shape({
    errorSites: PropTypes.bool,
    nonComm: PropTypes.bool,
    nullNan: PropTypes.bool,
    sysFailure: PropTypes.bool,
    underPerf: PropTypes.bool,
  }).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    prospectId: PropTypes.string,
    vendor: PropTypes.string,
    serialNumber: PropTypes.string,
  })).isRequired,
};

export default AdsRulesTable;
